import { getS3AssetCDNUrl } from "features/Common/modules/File/modules/Upload/utils/FileUpload.utils";
import {
  DRM_CHANNEL_SUBSCRIPTION_ASSETS_RELATIVE_PATH,
  MY_SUBSCRIPTIONS_CDN_ASSETS_RELATIVE_PATH,
  OMNI_CHANNEL_SUBSCRIPTION_ASSETS_RELATIVE_PATH,
  UBP_FEATURES_CDN_ASSETS_RELATIVE_PATH,
  LICENSE_CAROUSEL_ASSETS_RELATIVE_PATH,
} from "../constants/MySubscriptions.constants";

export const getLicenseCarouselAssets = (key) => {
  return getS3AssetCDNUrl(`${LICENSE_CAROUSEL_ASSETS_RELATIVE_PATH}/${key}`);
};

export const getOmniChannelSubscriptionAssets = (key) => {
  return getS3AssetCDNUrl(
    `${OMNI_CHANNEL_SUBSCRIPTION_ASSETS_RELATIVE_PATH}/${key}`
  );
};

export const getDrmSubscriptionAssets = (key) => {
  return getS3AssetCDNUrl(
    `${DRM_CHANNEL_SUBSCRIPTION_ASSETS_RELATIVE_PATH}/${key}`
  );
};

export const getMySubscriptionsAssets = (key) => {
  return getS3AssetCDNUrl(
    `${MY_SUBSCRIPTIONS_CDN_ASSETS_RELATIVE_PATH}/${key}`
  );
};

export const getUBPFeaturesAssets = (key) => {
  return getS3AssetCDNUrl(`${UBP_FEATURES_CDN_ASSETS_RELATIVE_PATH}/${key}`);
};
